module.exports = __webpack_public_path__ + "img/languageScore3.e06a4bbd.png";